<template>
  <v-footer dark padless>
    <v-layout style="backgroung-color:#3b3b3b;" wrap py-3 align-center>
      <v-flex xs12 md6 pl-12>
        <router-link to="/">
          <span class="AppFooter">ECOSYSTEM INVESTOR PLATFORM</span>
        </router-link>
      </v-flex>
      <v-flex xs12 md6 text-lg-right pr-12>
        <v-btn
          v-for="(item,i) in footer"
          :key="i"
          text
          :ripple="true"
          class="AppFooterItems"
          router-link
          :to="item.route"
        >{{item.name}}</v-btn>
      </v-flex>
    </v-layout>
  </v-footer>
</template>
<script>
export default {
  data() {
    return {
      footer: [
        { name: "Query", route: "/Query" },
        { name: "Terms and Conditions", route: "/TermsAndConditions" },
        { name: "Investment Risks", route: "/InvestmentRisks" },
        { name: "Business Continuity", route: "/BusinessContinuity" }
      ]
    };
  }
};
</script>
<style >
.AppFooter {
  font-size: 16px;
  color: white;
  font-family: proxima;
  letter-spacing: 1px !important;
}
.AppFooterItems {
  font-family: montserrat;
  color: white;
  font-size: 12px !important;
  text-transform: capitalize;
}
footer.theme--dark.v-card {
  background-color: #3b3b3b !important;
}
</style>